<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <rwidget-privacy></rwidget-privacy>
        </div>
    </div>
</div>
